import { render, staticRenderFns } from "./createAccount.vue?vue&type=template&id=f9fc515e&scoped=true"
import script from "./createAccount.vue?vue&type=script&lang=js"
export * from "./createAccount.vue?vue&type=script&lang=js"
import style0 from "./createAccount.vue?vue&type=style&index=0&id=f9fc515e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fc515e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9fc515e')) {
      api.createRecord('f9fc515e', component.options)
    } else {
      api.reload('f9fc515e', component.options)
    }
    module.hot.accept("./createAccount.vue?vue&type=template&id=f9fc515e&scoped=true", function () {
      api.rerender('f9fc515e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/cmp/createAccount.vue"
export default component.exports